import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

import { IExportYearlyBalance } from 'modules/shift_management/lib/types'

export const exportYearlyBalance = async (payload: IExportYearlyBalance): Promise<void> => {
  const api = ApiClient()
  const url = `/time_balance/employee_time_infos/export`
  return await api.post(url, payload)
}
